import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/$workspace/_dashboard/implementations/$id',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$workspace/tasks/$id',
      params,
      replace: true,
    })
  },
})
